import axios from 'axios';

const getCotacoesProdutos = (path, params) => axios.get(path, { params });

export default {
  getCotacoesProdutos,
};
